import { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

const STATUS = ["new", "contacted", "registered", "declined"];

const FORMAT_LABEL = { in_person: "In person", virtual: "Virtual", either: "Either" };
const EXP_LABEL = { beginner: "Beginner", some: "Some experience", experienced: "Experienced" };

export default function AdminWorkshops() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/workshop-interests").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const update = async (id, status) => {
    try {
      await api.put(`/admin/workshop-interests/${id}`, { status });
      toast.success("Updated");
      load();
    } catch (e) { toast.error(formatErr(e)); }
  };

  const del = async (id) => {
    if (!confirm("Remove this entry?")) return;
    try {
      await api.delete(`/admin/workshop-interests/${id}`);
      toast.success("Removed");
      load();
    } catch (e) { toast.error(formatErr(e)); }
  };

  return (
    <div data-testid="admin-workshops-page">
      <div className="flex items-baseline gap-3 mb-10">
        <h1 className="font-display text-4xl text-[#F5F5DC]">Workshop Waitlist</h1>
        <span className="smallcaps text-[#A3A3A3]">{items.length} {items.length === 1 ? "person" : "people"}</span>
      </div>

      <div className="space-y-4">
        {items.map((o) => (
          <div key={o.id} className="bg-[#111] border border-[#2A2A2A] p-6" data-testid={`waitlist-${o.id}`}>
            <div className="flex justify-between items-start gap-4 mb-3 flex-wrap">
              <div>
                <p className="font-display text-xl text-[#F5F5DC]">{o.name}</p>
                <p className="text-[#A3A3A3] text-sm">
                  <a href={`mailto:${o.email}`} className="hover:text-[#B87333]">{o.email}</a>
                  {o.phone && <> · {o.phone}</>}
                </p>
                <p className="text-xs text-[#555] mt-1">{new Date(o.created_at).toLocaleString()}</p>
              </div>
              <div className="flex items-center gap-2">
                <select
                  value={o.status}
                  onChange={(e) => update(o.id, e.target.value)}
                  className="input-dark w-auto text-xs"
                  data-testid={`wi-status-${o.id}`}
                >
                  {STATUS.map((s) => <option key={s} value={s}>{s.toUpperCase()}</option>)}
                </select>
                <button onClick={() => del(o.id)} className="text-[#A3A3A3] hover:text-[#CF6679] p-2" data-testid={`wi-delete-${o.id}`}>
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
            <div className="grid sm:grid-cols-3 gap-2 text-sm text-[#A3A3A3] mb-3">
              <p><span className="smallcaps">Experience:</span> {EXP_LABEL[o.experience_level] || o.experience_level}</p>
              <p><span className="smallcaps">Format:</span> {FORMAT_LABEL[o.preferred_format] || o.preferred_format}</p>
              <p><span className="smallcaps">Topics:</span> {(o.topics || []).length || "—"}</p>
            </div>
            {o.topics?.length > 0 && (
              <div className="flex flex-wrap gap-2 mb-3">
                {o.topics.map((t) => (
                  <span key={t} className="text-xs uppercase tracking-wider border border-[#2A2A2A] px-3 py-1 text-[#A3A3A3]">{t}</span>
                ))}
              </div>
            )}
            {o.notes && (
              <p className="text-[#F5F5DC] text-sm whitespace-pre-wrap border-t border-[#2A2A2A] pt-3">{o.notes}</p>
            )}
          </div>
        ))}
        {items.length === 0 && <p className="text-[#A3A3A3]">No interest signups yet.</p>}
      </div>
    </div>
  );
}
